import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-auto-update-dialog',
  templateUrl: './auto-update-dialog.component.html',
  styleUrls: ['./auto-update-dialog.component.scss']
})
export class AutoUpdateDialogComponent implements OnInit {

  heading;
  content;
  actionText;

  constructor(  @Inject(MAT_DIALOG_DATA) public _data: any,
        public matDialogRef: MatDialogRef<AutoUpdateDialogComponent>,) { 
          this.heading = this._data.heading || '';
          this.content = this._data.content || '';
          this.actionText = this._data.actionText || '';
        }

  ngOnInit(): void {
  }

}
